---
title: Pocket synth
description: "A synth device: a waveform, a filter and a volume, a panel with a pad that plays it, a Web Audio engine with noteOn and noteOff, and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-pocket-synth" />

One oscillator through a resonant filter. Press the pad: the pitch goes across and the filter cutoff goes up. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="pocket-synth" kind="device" />

## Controls

<DeviceControls device="pocket-synth">
<Control id="wave">The wave of the oscillator.</Control>
<Control id="filter">The type of the filter.</Control>
<Control id="volume">The level of the output.</Control>
</DeviceControls>

## Panel

The panel has a pad that plays the synth: its position gives the note, so the pitch goes across and the cutoff goes up. `pocketSynthPitch(position)` and `pocketSynthCutoff(position)` turn a position from 0 to 1 into hertz. The panel sends notes out and does not make the sound, so it plays through any engine.

<DeviceUsage name="pocket-synth" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

```ts
engine.noteOn(note); // starts a note now, or glides the one being held
engine.noteOff(); // lets it go

// Scheduled ahead on the audio clock, by a host that plays notes from a song:
engine.noteOn({ ...note, velocity: 0.8 }, { at: time, id: "c4" });
engine.noteOff({ at: time + length, id: "c4" });
```

One voice at a time. `noteOn` starts a note, or glides the one being held to the new one, and `noteOff` releases it. Both take an optional `{ at, id }`: `at` is a time of the audio clock, now when there is none, and a `noteOff` whose `id` is not the held note's lets nothing go, since the held note took over from it. A note plays as loud as its `velocity`, from 0 to 1. The wave and the filter type of a state change under a held note. An agent plays the synth with the `play` tool.
